import React from 'react';
import Helmet from '../components/Helmet'
import OfferSection from '../components/OfferSection';

const seo = 'CustomArt to 12 lat doświadczenia scenicznego, ogromna sieć kontaktów, doskonała znajomość potrzeb zarówno agencji, klientów bezpośrednich jak i samych artystów oraz rozbudowana oferta usług dodatkowych.'

const Offer = () => {
  return (
    <div>
      <Helmet title="Oferta">
        <meta name="description" content={seo} />
      </Helmet>
      <OfferSection />
      <div style={{paddingTop: 100}} />
    </div>
  )
}

export default Offer;


// WEBPACK FOOTER //
// ./src/pages/oferta.js